import React from "react";
import { connect } from "react-redux";
import { arrayOf, bool, object, string } from "prop-types";
import { flatten } from "lodash";

import Anchor from "../Anchor";
import RightArrow from "../icons/right-arrow";

import { getCollectionName, getSlug, validURL } from "../../utils/utils";
import { MICROSITES_OLD_URLS } from "../../../../server/helpers/constants";

import "./collection-title-with-arrow.m.css";

const CollectionTitleWithArrow = ({
  collection,
  sections,
  domainSlug,
  disableArrow = false,
  className = "",
  border = true,
  arrowColor,
}) => {
  const { navigate_to: navigateTo, navigate_to_title: navigateToTitle } = collection["associated-metadata"] || {};

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = getSlug(collection, sections, domainSlug, navigateTo);

  const genCollectionSlug = () => {
    if (validURL(collectionSlug)) return collectionSlug;

    const flattenedUrls = flatten(MICROSITES_OLD_URLS);
    const slugIndex = flattenedUrls.indexOf(collectionSlug);
    return slugIndex >= 0 ? flattenedUrls[slugIndex + 1] : collectionSlug;
  };

  const url = genCollectionSlug();

  return (
    <h2 className={className} styleName="base">
      <Anchor
        aria-label={collectionName}
        href={url}
        styleName={`headline ${border ? "border-top" : ""}`}
        className="collection-title"
      >
        <span className="headline-color" styleName={`headline-text ${navigateTo === "#" ? "no-link" : ""}`}>
          {collectionName}
        </span>
        {!disableArrow && navigateTo !== "#" && <RightArrow color={arrowColor} />}
      </Anchor>
    </h2>
  );
};

CollectionTitleWithArrow.propTypes = {
  collection: object,
  sections: arrayOf(object),
  domainSlug: string,
  disableArrow: bool,
  className: string,
  border: bool,
  arrowColor: string,
};

const mapStateToProps = (state) => ({
  sections: state.qt.config.sections,
  domainSlug: state.qt.config.domainSlug,
});

export default connect(mapStateToProps)(CollectionTitleWithArrow);
